import React from 'react';
import DogDisplayPage from './DogDisplayPage';
import { WidePhoto, TallPhoto, SquarePhoto } from './Constants';
import makara1 from './assets/images/makara/makara1.jpg';
import makara2 from './assets/images/makara/makara2.jpg';
import makara3 from './assets/images/makara/makara3.jpg';
import makara4 from './assets/images/makara/makara4.jpg';
import makara5 from './assets/images/makara/makara5.jpg';
import makara6 from './assets/images/makara/makara6.jpg';
import makara7 from './assets/images/makara/makara7.jpg';
import makara8 from './assets/images/makara/makara8.jpg';
import makara9 from './assets/images/makara/makara9.jpg';
import makara10 from './assets/images/makara/makara10.jpg';
import makara11 from './assets/images/makara/makara11.jpg';
import makara12 from './assets/images/makara/makara12.jpg';
import makara13 from './assets/images/makara/makara13.jpg';
import makara14 from './assets/images/makara/makara14.jpg';
import makara15 from './assets/images/makara/makara15.jpg';
import makara16 from './assets/images/makara/makara16.jpg';
import makara17 from './assets/images/makara/makara17.jpg';
import makara18 from './assets/images/makara/makara18.jpg';


const photos = [
    { src: makara1, ...WidePhoto },
    { src: makara2, ...WidePhoto },
    { src: makara3, ...WidePhoto },
    { src: makara4, ...SquarePhoto },
    { src: makara5, ...WidePhoto },
    { src: makara6, ...WidePhoto },
    { src: makara7, ...WidePhoto },
    { src: makara8, ...WidePhoto },
    { src: makara9, ...WidePhoto },
    { src: makara10, ...WidePhoto },
    { src: makara11, ...WidePhoto },
    { src: makara12, ...WidePhoto },
    { src: makara13, ...WidePhoto },
    { src: makara14, ...TallPhoto },
    { src: makara15, ...TallPhoto },
    { src: makara16, ...TallPhoto },
    { src: makara17, ...TallPhoto },
    { src: makara18, ...WidePhoto },
];

const Makara = () => {
    return (
        <DogDisplayPage photos={photos}>
            <h1 className="female">
                <i className="far fa-venus"></i>
                Makara
            </h1>
            <table className="dog-chart">
                <tbody>
                    <tr>
                        <td><span className="title">Name</span>LUNANOVA'S LEGENDARY sea creature</td>
                        <td><span className="title">Owner</span>CAROLYNNE ISSA</td>
                        <td><span className="title">CKC Registration</span>#JW4136936</td>
                    </tr>
                    <tr>
                        <td><span className="title">Sire</span>CH LUNANOVA'S CHILKO FREESTONE</td>
                        <td><span className="title">Dam</span>CH SKIPNSTONES GODDESS AT LUNANOVA JWD</td>
                    </tr>
                    <tr>
                        <td><span className="title">Coat Type</span>WAVY</td>
                        <td><span className="title">Coat Colour</span>BLACK WITH WHITE MARKINGS</td>
                    </tr>
                    <tr>
                        <td><span className="title">CAER</span>NORMAL</td>
                        <td><span className="title">CDDY/IVVD</span>NORMAL</td>
                        <td><span className="title">EOPRA</span>NORMAL</td>
                    </tr>
                    <tr>
                        <td><span className="title">GM-1</span>normal</td>
                        <td><span className="title">Improper Coat</span>normal</td>
                        <td><span className="title">JDCM</span>normal</td>
                        <td><span className="title">MICROPHTHALMIA SYNDROME</span>CARRIER</td>
                    </tr>
                    <tr>
                        <td><span className="title">OFA Hips</span>GOOD (ELBOWS NORMAL)	</td>
                        <td><span className="title">PRA</span>normal</td>
                    </tr>
                </tbody>
            </table>
        </DogDisplayPage>
    )
}
export default Makara;
